<script>
import { Helper } from '@/mixin/helper'
import McGraphqlEditableTable from '@/components/McGraphqlEditableTable'
import {
  GET_DEPARTMENT,
  DEPARTMENT_MUTATION_CREATE,
  DEPARTMENT_MUTATION_UPDATE,
  DEPARTMENT_MUTATION_DELETE,
} from '@/services/api/setting/employee/department'

export default {
  components: { McGraphqlEditableTable },
  mixins: [Helper],
  props: {
    status: String,
  },
  data() {
    return {
      data: [],
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'name',
          label: this.$t('setting.list.employeeSetting.department'),
          placeholder: this.$t('setting.list.employeeSetting.department'),
          inputName: 'deptName',
          thClass: 'mc-table--50',
          isSortable: true,
          editable: true,
          validation: [['required']],
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          filter.level = [1]
          filter.isPosition = false
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_DEPARTMENT,
            variables: {
              filter: filter,
            },
          })
          let self = this
          self.data = res.data.companyStructures.companyStructures.data

          let result = res.data.companyStructures.companyStructures
          result.data.forEach((item, index) => {
            if (item.companyId == 1) {
              result.data[index].disableCheckbox = true
              result.data[index].isShowEdit = false
            } else if (item.hasRelation) {
              result.data[index].disableCheckbox = true
              result.data[index].isShowEdit = true
            }
          })

          return result
        },
        store: async (data) => {
          const res = await this.$apollo.mutate({
            mutation: DEPARTMENT_MUTATION_CREATE,
            variables: {
              input: {
                name: data.deptName,
                level: 1,
                isPosition: false,
              },
            },
          })
          if (
            res.data.createCompanyStructure.message
              .toLowerCase()
              .includes('company structure name was exist')
          ) {
            this.$mcToast.warning(this.$t('setting.list.employeeSetting.alert.departmentExist'))
            return
          }
          let self = this
          let newData = res.data.createCompanyStructure.companyStructure
          newData.hasRelation = false
          self.data.push(newData)

          return res.data.createCompanyStructure.companyStructure
        },
        update: async (id, oldData, newData) => {
          const res = await this.$apollo.mutate({
            mutation: DEPARTMENT_MUTATION_UPDATE,
            variables: {
              input: {
                name: newData.deptName,
                structureId: Number(id),
              },
            },
          })
          if (
            res.data.updateCompanyStructure.message
              .toLowerCase()
              .includes('company structure name was exist')
          ) {
            this.$mcToast.warning(this.$t('setting.list.employeeSetting.alert.departmentExist'))
            return
          }
          let self = this
          let dataUpdateIndex = self.data.findIndex((item) => item.structureId == id)

          if (dataUpdateIndex !== -1) {
            self.data[dataUpdateIndex].name = newData.deptName
          }

          const updateData = res.data.updateCompanyStructure.companyStructure
          updateData.hasRelation = oldData.hasRelation
          if (updateData.companyId == 1) {
            updateData.disableCheckbox = true
            updateData.isShowEdit = false
          } else if (updateData.hasRelation) {
            updateData.disableCheckbox = true
            updateData.isShowEdit = true
          }
          return updateData
        },
        delete: async (id) => {
          const res = await this.$apollo.mutate({
            mutation: DEPARTMENT_MUTATION_DELETE,
            variables: {
              input: {
                structureId: Number(id),
              },
            },
          })

          return res.data.deleteCompanyStructure.isSuccessful
        },
      }
    },
  },
  mounted() {
    this.$store.commit('setting/SET_STATUS', this.status)
  },
}
</script>

<template>
  <!-- Departemen -->
  <b-tab class="border-0" @click="$store.commit('setting/SET_STATUS', status)">
    <template #title>
      <span class="d-sm-inline-block">{{ $t('setting.list.employeeSetting.department') }}</span>
    </template>

    <!-- Table -->
    <div class="table-responsive my-3">
      <McGraphqlEditableTable
        :fields="fields"
        :apiClient="query"
        trackBy="structureId"
        :searchable="true"
      />
    </div>
  </b-tab>
</template>
